import { gql } from '@apollo/client';

import TASK_FRAGMENT from 'components/projects/taskList/gql/TaskFragment.graphql';

export default gql`
  fragment TaskListSectionlessFragment on TaskList {
    id
    uuid
    tasks(first: $first, after: $after, withoutSection: true) {
      __typename
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...TaskFragment
      }
    }
  }
  ${TASK_FRAGMENT}
`;
